import _ from "lodash";
import { payersNoun } from "../../utilities/charts/chart_utils";
import ChartControllerBase from "./chart_controller_base";

export default class extends ChartControllerBase {
  connect() {
    this.payerTypeInputTargets = $("input[type=radio][name=payer_type]")
      .toArray()
      .filter(target => this.payerTypesIncluded.includes(target.value));

    $(this.payerTypeInputTargets).on("change", event => this.togglePayerTypeFromButton(event));

    this.drugInputTargets = $("input[type=checkbox][name=drugs]")
      .toArray()
      .filter(target => this.drugsIncluded.includes(target.value));

    $(this.drugInputTargets).on("change", event => this.toggleDrugFromButton(event));

    this.coverageInputTargets = $("input[name=coverage_metric_toggle]").toArray();
    $(this.coverageInputTargets).on("change", event => this.toggleCoverageMetric(event));

    $("#account_manager").on("change", () => this.updateShownPayers());
    $("#region").on("change", () => this.updateShownPayers());

    this.params = this.initializeParams();
    this.chart = this.renderChart();
  }

  togglePayerTypeFromButton(event) {
    this.payerType = event.target.value;

    this.togglePayerTypeInternal(event.target.value, event.target.checked);

    this.chart?.update();
  }

  toggleDrugFromChart(legendItem) {
    const { drug } = this.chart.data.datasets[legendItem.datasetIndex];
    const button = this.drugInputTargets.find(target => target.value === drug);

    $(button).trigger("click");
  }

  toggleDrugFromButton(event) {
    const drug = event.target.value;

    if (this.drugsIncluded.includes(drug)) {
      this.drugs = _.xor(this.drugs, [drug]).sort();

      this.toggleDrugsInternal();

      this.chart?.update();
    }
  }

  toggleCoverageMetric() {
    this.toggleCoverageMetricInternal();

    this.chart?.update();
  }

  updateShownPayers() {
    this.updateShownPayersInternal();

    this.chart?.update();
  }

  initializeParams() {
    const params = JSON.parse(this.data.get("chartData")) || {};

    if (this.inStaticMode) {
      this.payerType = _.first(this.payerTypesIncluded);
      this.drugs = this.drugsIncluded;
    } else {
      this.payerType =
        this.payerTypesIncluded.length === 1
          ? this.payerTypesIncluded[0]
          : this.payerTypeInputTargets.find(target => target.checked)?.value;

      this.drugs = this.isFixedDrug
        ? this.drugsIncluded
        : this.drugInputTargets.filter(target => target.checked).map(target => target.value);
    }

    return params;
  }

  get subtitles() {
    return {
      payers: payersNoun(this.payerType),
      lives: "Millions of Lives",
    };
  }

  togglePayerTypeInternal() {
    // Implement in subclass if needed
  }

  toggleDrugsInternal() {
    // Implement in subclass if needed
  }

  toggleCoverageMetricInternal() {
    // Implement in subclass if needed
  }
}
